import state from './data.state'
import mutations from './data.mutations'
import actions from './data.actions'

export default {
  state,
  mutations,
  actions
}
